import { SVGProps, Ref, forwardRef } from 'react';

export const GhostFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m14.618 6.636.38 7.431c.056 1.091-1.181 1.8-2.154 1.233l-1.247-.725a1.47 1.47 0 0 0-1.502.018l-.946.581c-.7.43-1.597.43-2.297 0l-.947-.582a1.47 1.47 0 0 0-1.502-.017l-1.247.725c-.973.566-2.21-.142-2.154-1.233l.38-7.431C1.58 3.016 4.15.46 8 .5c3.852-.04 6.42 2.515 6.618 6.136M5.01 5.466c.205-.246.527-.4.988-.4.462 0 .784.154.988.4.202.242.279.56.279.866s-.077.623-.279.866c-.204.245-.526.4-.988.4s-.783-.155-.988-.4c-.202-.243-.278-.56-.278-.866 0-.307.076-.624.278-.866m4 0c.204-.246.526-.4.987-.4.462 0 .784.154.989.4.201.242.278.56.278.866s-.077.623-.278.866c-.205.245-.527.4-.989.4s-.783-.155-.988-.4c-.202-.243-.278-.56-.278-.866 0-.307.076-.624.278-.866"
                fill="currentColor"
            />
        </g>
    </svg>
));
GhostFilledSize16Glyph.displayName = 'GhostFilledSize16Glyph';
